// extracted by mini-css-extract-plugin
export var footer = "_kp-0";
export var inherit = "_kp-1";
export var input = "_kp-2";
export var modalContent = "_kp-3";
export var quillEditor = "_kp-4";
export var subtitle = "_kp-5";